import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlConstants, API_ENDPOINTS } from '@varsity/commons';
import { HttpHelperService } from '@varsity/services';

@Injectable()
export class SettingsService {
    constructor(private httpHelperService: HttpHelperService) { }

    getSystemRoles(system: string, token: string): Observable<any> {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getSystemRoles;
        return this.httpHelperService.get<any>(url, {
            params: {
                "X-Token": token,
                site: system
            }
        })

    }
}



// WEBPACK FOOTER //
// ./src/services/settings/settings.service.ts